// Item cross-reference filters (PD-17504). Both lists are served by
// ItemCrossReferenceListService, which reads these keys off the filters blob
// itself and builds its own SQL (joinType 'custom'): the rows are a union of
// client_item and item_cross_reference, which the shared filter builder
// cannot express.

import {
	ITEM_CROSS_REFERENCE_ROW_KIND_LABELS,
	ITEM_CROSS_REFERENCE_ROW_KINDS,
} from '@supply-mover-2-0/shared';
import { createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

// The Cross-References list under Items. An item's tab shows its few rows
// without the filter bar.
const ITEM_CROSS_REFERENCE_LIST_KEYS = ['item-cross-references'];

export const itemCrossReferenceFilters: FilterRegistry = {
	itemCrossReferenceKeywords: {
		...createKeywordFilter({
			label: 'Search',
			placeholder: 'Their number, customer or our item',
			objectTable: 'item_cross_reference',
			listKeys: ITEM_CROSS_REFERENCE_LIST_KEYS,
		}),
		queryMapping: { objectTable: 'item_cross_reference', joinType: 'custom' },
		queryParamName: 'itemCrossReferenceKeywords',
	},
	itemCrossReferenceKind: {
		type: 'multi-select',
		label: 'Kind',
		placeholder: 'Select kind...',
		colorScheme: 'blue',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		options: ITEM_CROSS_REFERENCE_ROW_KINDS.map((kind) => ({
			id: kind,
			label: ITEM_CROSS_REFERENCE_ROW_KIND_LABELS[kind],
		})),
		queryParamName: 'itemCrossReferenceKind',
		multiple: true,
		queryMapping: { objectTable: 'item_cross_reference', fieldName: 'kind', joinType: 'custom' },
		format: 'array',
		valueExtractor: {
			property: 'id',
		},
		listKeys: ITEM_CROSS_REFERENCE_LIST_KEYS,
	},
};
